import { EContactDetailTypes, TResetData } from '../index';
import { initialState } from '../initialState';

export const resetAddress = (): TResetData => ({
    type: EContactDetailTypes.RESET_DATA,
    payload: initialState,
});
